@switch (appearance()) {
  @case ('inline') {
    <div class="lp-inline" role="radiogroup">
      @for (opt of options; track opt.value) {
        <button
          type="button"
          role="radio"
          class="lp-inline-item"
          [class.is-active]="language() === opt.value"
          [attr.aria-checked]="language() === opt.value"
          [disabled]="disabled()"
          (click)="select(opt.value)"
        >
          <img class="lp-flag" [ngSrc]="opt.flag" alt="" width="16" height="16" />
          <span class="lp-code">{{ opt.value | uppercase }}</span>
        </button>
      }
    </div>
  }
  @case ('cards') {
    <div class="lp-cards" role="radiogroup">
      @for (opt of options; track opt.value) {
        <button
          type="button"
          role="radio"
          class="lp-card"
          [class.is-active]="language() === opt.value"
          [attr.aria-checked]="language() === opt.value"
          [disabled]="disabled()"
          (click)="select(opt.value)"
        >
          <span class="lp-card-head">
            <img class="lp-flag lp-flag--lg" [ngSrc]="opt.flag" alt="" width="24" height="24" />
            <span class="lp-code">{{ opt.value | uppercase }}</span>
          </span>
          <span class="lp-name">{{ opt.label }}</span>
        </button>
      }
    </div>
  }
}
